/**
 * Checkout functionality.
 *
 * This file should be cleaned up, maybe changed from using jQuery everywhere too.
 */

jQuery( document ).ready( function( $ ) {
	// we need this code for the custom coupon code placement in checkout
	if ( ! $( '.checkout-toggle-section' ).length ) {
		return;
	}

	// Cache DOM elements for reuse
	const $couponBtn = $( '.checkout-toggle-section.coupon-toggle' );
	const $couponForm = $( '#coupon_container' );
	const $billingCompanyLabel = $( '#billing_company_field > label' );
	const $couponCodeInput = $( '#coupon_code' );
	const $applyCouponBtn = $( '#apply_coupon_btn' );
	const nonce = window?.qalaThemeData?.applyCouponNonce;

	// Toggle coupon form visibility
	if ( $couponBtn.length > 0 ) {
		$couponBtn.click( function() {
			$couponForm.toggleClass( 'woocommerce-form-coupon--show' );
			$( this ).toggleClass( 'active' );
			if ( $( '.woocommerce-error' ).length ) {
				$( '.woocommerce-error' ).remove();
			}
		} );
	}

	// Toggle billing company input visibility, making it invisible by default.
	if ( $billingCompanyLabel.length > 0 ) {
		$billingCompanyLabel.click( function() {
			const $billingCompanyInput = $( 'input#billing_company' );
			if ( ! $billingCompanyInput ) {
				return;
			}

			$billingCompanyInput.toggle();
		} );
	}

	// Prevent form submission when hitting Enter in the coupon code input.
	// Instead, lets trigger the coupon button.
	$couponCodeInput.on( 'keydown', function( event ) {
		if ( event.which === 13 ) {
			event.preventDefault();
			$applyCouponBtn.trigger( 'click' );
		}
	} );

	// Apply coupon using AJAX when clicking 'Apply coupon' button
	$applyCouponBtn.click( function( event ) {
		event.preventDefault();

		const couponCode = $couponCodeInput.val();

		// Show loading overlay
		$( 'body' ).block( {
			message: null,
			overlayCSS: {
				background: '#fff',
				opacity: 0.6,
			},
		} );

		const ajaxUrl = window?.wc_checkout_params?.ajax_url;

		// Make AJAX request to apply coupon
		$.ajax( {
			type: 'POST',
			url: ajaxUrl,
			data: {
				action: 'apply_coupon_code',
				coupon_code: couponCode,
				security: nonce,
			},
			success( response ) {
				if ( response.success ) {
					$( 'body' ).trigger( 'update_checkout' );
					$couponForm.removeClass( 'woocommerce-form-coupon--show' );
					$couponBtn.toggleClass( 'active' );
				} else {
					$( '#coupon_container' ).before(
						'<div class="woocommerce-error">' + response.data + '</div>'
					);
				}
			},
			complete() {
				$( 'body' ).unblock();
			},
		} );
	} );
} );

jQuery( document.body ).on( 'updated_checkout', function() {
	const checkoutNewsletterCheckbox = document.getElementById( 'checkout-newsletter' );
	const klaviyoCheckbox = document.getElementById( 'kl_newsletter_checkbox' );

	if ( checkoutNewsletterCheckbox === null || klaviyoCheckbox === null ) {
		return;
	}

	if ( checkoutNewsletterCheckbox ) {
		checkoutNewsletterCheckbox.addEventListener( 'change', function() {
			if ( this.checked ) {
				klaviyoCheckbox.checked = true;
			} else {
				klaviyoCheckbox.checked = false;
			}
		} );
	}
} );

jQuery( document.body ).on( 'updated_checkout', function() {
	const checkoutViewMore = document.querySelector( '.shop-table-view-more' );
	const checkoutViewMoreBtn = document.getElementById( 'checkout-view-more' );
	const checkoutTable = document.querySelector( '.shop_table--max-3-mobile' );

	if ( ! checkoutViewMore || ! checkoutTable || ! checkoutViewMoreBtn ) {
		return;
	}

	if ( checkoutViewMoreBtn ) {
		checkoutViewMoreBtn.removeAttribute( 'disabled' );
		checkoutViewMoreBtn.addEventListener( 'click', function( event ) {
			event.preventDefault();
			checkoutTable.classList.toggle( 'shop_table--max-3-mobile-show' );
			if ( checkoutViewMoreBtn.innerHTML === checkoutViewMoreBtn.dataset.btnHideText ) {
				checkoutViewMoreBtn.innerHTML = checkoutViewMoreBtn.dataset.btnShowText;
			} else {
				checkoutViewMoreBtn.innerHTML = checkoutViewMoreBtn.dataset.btnHideText;
			}
			checkoutViewMoreBtn.blur();
		} );
	}
} );

const jumpToOrderReview = document.querySelector( '.jump-to-order-review a' );
const orderReviewSection = document.querySelector( 'form.checkout' );

if ( jumpToOrderReview && orderReviewSection ) {
	jumpToOrderReview.addEventListener( 'click', function( event ) {
		event.preventDefault();
		window.scroll( { top: orderReviewSection.offsetTop, behavior: 'smooth' } );
	} );
}
